import { render, staticRenderFns } from "./referral-programs-new.vue?vue&type=template&id=27854080&scoped=true&"
import script from "./referral-programs-new.vue?vue&type=script&lang=js&"
export * from "./referral-programs-new.vue?vue&type=script&lang=js&"
import style0 from "./referral-programs-new.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./referral-programs-new.vue?vue&type=style&index=1&id=27854080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27854080",
  null
  
)

export default component.exports